/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validate & decode IDs`)
};

const es_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valida y decodifica identificadores`)
};

const de_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDs validieren & decodieren`)
};

const nl_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valideer en decodeer ID's`)
};

const fr_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valider et décoder les identifiants`)
};

const it_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convalida e decodifica ID`)
};

const pt_br2_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valide e decodifique IDs`)
};

const pt_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valide e descodifique IDs`)
};

const ja_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID を検証およびデコード`)
};

const zh_ud_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证并解码标识符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_nav_main_desc", locale)
	if (locale === "en") return en_ud_nav_main_desc(inputs)
	if (locale === "es") return es_ud_nav_main_desc(inputs)
	if (locale === "de") return de_ud_nav_main_desc(inputs)
	if (locale === "nl") return nl_ud_nav_main_desc(inputs)
	if (locale === "fr") return fr_ud_nav_main_desc(inputs)
	if (locale === "it") return it_ud_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_ud_nav_main_desc(inputs)
	if (locale === "pt") return pt_ud_nav_main_desc(inputs)
	if (locale === "ja") return ja_ud_nav_main_desc(inputs)
	return zh_ud_nav_main_desc(inputs)
};